import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { programService } from '../../services/firebaseService';
import { Program } from '../../types';
import MarkdownEditor from '../../components/admin/MarkdownEditor';

const ProgramManager: React.FC = () => {
  const [programs, setPrograms] = useState<Program[]>([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState<Partial<Program>>({ title: '', description: '', isActive: true });
  const [editingId, setEditingId] = useState<string | null>(null);

  useEffect(() => {
    programService.getAllPrograms().then(list => {
      setPrograms(list);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (editingId) {
      await programService.updateProgram(editingId, form as Program);
    } else {
      await programService.addProgram(form as Program);
    }
    const list = await programService.getAllPrograms();
    setPrograms(list);
    setForm({ title: '', description: '', isActive: true });
    setEditingId(null);
  }

  function startEdit(p: Program) {
    setEditingId(p.id!);
    setForm({ title: p.title, description: p.description, isActive: (p as any).isActive !== false });
  }

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <h3>Admin Panel</h3>
        <nav>
          <ul>
            <li><Link to="/admin">Dashboard</Link></li>
            <li><Link to="/admin/content">Content</Link></li>
            <li><Link to="/admin/board">Board Members</Link></li>
            <li><Link to="/admin/programs">Programs</Link></li>
            <li><Link to="/admin/events">Events</Link></li>
            <li><Link to="/admin/volunteers">Volunteer Applications</Link></li>
            <li><Link to="/admin/contact">Contact Submissions</Link></li>
          </ul>
        </nav>
      </div>
      <div className="admin-content">
        <h1>Program Manager</h1>

        <form onSubmit={handleSubmit} style={{ marginBottom: '2rem' }}>
          <div className="grid" style={{ gridTemplateColumns: '1fr' }}>
            <input
              type="text"
              placeholder="Title"
              value={form.title || ''}
              onChange={e => setForm({ ...form, title: e.target.value })}
              required
            />
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>Description</label>
              <MarkdownEditor
                value={form.description || ''}
                onChange={(value) => setForm({ ...form, description: value })}
                placeholder="Enter program description..."
              />
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <input
                type="checkbox"
                checked={(form as any).isActive !== false}
                onChange={e => setForm({ ...form, isActive: e.target.checked })}
              />
              Active
            </label>
            <div>
              <button className="btn btn-primary" type="submit">{editingId ? 'Update' : 'Add'} Program</button>
              {editingId && (
                <button type="button" className="btn btn-secondary" style={{ marginLeft: '0.5rem' }} onClick={() => { setEditingId(null); setForm({ title: '', description: '', isActive: true }); }}>Cancel</button>
              )}
            </div>
          </div>
        </form>

        {loading ? (
          <div className="loading"><div className="spinner" /></div>
        ) : (
          <div className="grid" style={{ gridTemplateColumns: '1fr' }}>
            {programs.map(p => (
              <div key={p.id} className="card">
                <h3>{p.title}</h3>
                {p.description && <p>{p.description}</p>}
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <button className="btn btn-primary" onClick={() => startEdit(p)}>Edit</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgramManager;
